import React, { useEffect, useState, useRef } from 'react';
const purchases = [{
  name: 'Valentina M.',
  city: 'Buenos Aires',
  initials: 'VM',
  product: 'Megapack Kinesiología Carrera Resuelta',
  time: 'hace 2 min'
}, {
  name: 'Lucía R.',
  city: 'Córdoba',
  initials: 'LR',
  product: 'Megapack + Máster Kinesiología',
  time: 'hace 4 min'
}, {
  name: 'Camila S.',
  city: 'Rosario',
  initials: 'CS',
  product: 'Megapack Kinesiología Carrera Resuelta',
  time: 'hace 7 min'
}, {
  name: 'Sofía G.',
  city: 'La Plata',
  initials: 'SG',
  product: 'Megapack + Máster Kinesiología',
  time: 'hace 10 min'
}, {
  name: 'Martina P.',
  city: 'Mendoza',
  initials: 'MP',
  product: 'Megapack Kinesiología Carrera Resuelta',
  time: 'hace 13 min'
}, {
  name: 'Julieta F.',
  city: 'Tucumán',
  initials: 'JF',
  product: 'Megapack + Máster Kinesiología',
  time: 'hace 16 min'
}, {
  name: 'Florencia B.',
  city: 'Santa Fe',
  initials: 'FB',
  product: 'Megapack Kinesiología Carrera Resuelta',
  time: 'hace 19 min'
}, {
  name: 'Agustina L.',
  city: 'Mar del Plata',
  initials: 'AL',
  product: 'Megapack + Máster Kinesiología',
  time: 'hace 23 min'
}, {
  name: 'Rocío T.',
  city: 'Salta',
  initials: 'RT',
  product: 'Megapack Kinesiología Carrera Resuelta',
  time: 'hace 27 min'
}, {
  name: 'Milagros C.',
  city: 'San Juan',
  initials: 'MC',
  product: 'Megapack + Máster Kinesiología',
  time: 'hace 31 min'
}, {
  name: 'Daniela V.',
  city: 'Neuquén',
  initials: 'DV',
  product: 'Megapack Kinesiología Carrera Resuelta',
  time: 'hace 35 min'
}, {
  name: 'Natalia H.',
  city: 'Paraná',
  initials: 'NH',
  product: 'Megapack + Máster Kinesiología',
  time: 'hace 40 min'
}];
const avatarColors: Record<string, string> = {
  VM: '#0e7490',
  LR: '#7c3aed',
  CS: '#b45309',
  SG: '#065f46',
  MP: '#9f1239',
  JF: '#1d4ed8',
  FB: '#92400e',
  AL: '#0e7490',
  RT: '#7c3aed',
  MC: '#065f46',
  DV: '#b45309',
  NH: '#1d4ed8'
};
export function PurchaseNotifications() {
  const [current, setCurrent] = useState<number | null>(null);
  const [visible, setVisible] = useState(false);
  const indexRef = useRef(0);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    function showNext() {
      setCurrent(indexRef.current);
      setVisible(true);
      timeoutRef.current = setTimeout(() => {
        setVisible(false);
        indexRef.current = (indexRef.current + 1) % purchases.length;
        const nextDelay = 12000 + Math.random() * 6000;
        timeoutRef.current = setTimeout(showNext, nextDelay);
      }, 4000);
    }
    timeoutRef.current = setTimeout(showNext, 8000);
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);
  const purchase = current !== null ? purchases[current] : null;
  if (!purchase) return null;
  const bgColor = avatarColors[purchase.initials] || '#1d4ed8';
  return <div className="fixed bottom-4 left-4 z-50 max-w-xs" style={{
    animation: visible ? 'notifIn 0.3s ease-out forwards' : 'notifOut 0.3s ease-in forwards',
    pointerEvents: 'none'
  }} data-id="element-263">
      <div className="flex items-center gap-3 bg-white rounded-xl shadow-lg border border-gray-200 px-4 py-3" data-id="element-264">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-xs font-black text-white" style={{
        backgroundColor: bgColor
      }} data-id="element-265">
          {purchase.initials}
        </div>
        <div className="min-w-0" data-id="element-266">
          <p className="text-xs font-bold text-gray-900 m-0 truncate" data-id="element-267">
            {purchase.name} — {purchase.city}
          </p>
          <p className="text-[10px] text-gray-500 m-0 truncate" data-id="element-268">
            Acaba de obtener {purchase.product}
          </p>
          <p className="text-[10px] text-blue-600 font-semibold m-0" data-id="element-269">
            ✓ {purchase.time}
          </p>
        </div>
      </div>
    </div>;
}